<template>
    <div>
        <TheHeader class="mob-header" />
        <BaseTitle class="example-title" :infor="infor" />
        <TheExampleExampleList :exampleList="mobExampleList" />
        <TheFooter class="mob-the-footer-other" />
    </div>
</template>

<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_mob-header.less'
    import '@/assets/less/module/module-the-footer-other_mob-the-footer-other.less'
    
    import BaseTitle from '@/components/module/BaseTitle'
    import TheExampleExampleList from '@/components/module/TheExampleExampleList'


    export default {
        name: 'MobExample',
        props: {
                infor: Object,
                exampleList: Array
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            TheExampleExampleList
        },
        data: function(){
            return {}
        },    
        mounted() {
        },
        computed: {
            mobExampleList: function(){
                let arr = JSON.parse(JSON.stringify(this.exampleList));
                for(let i=0, l=arr.length; i<l; i++){
                    arr[i].image = arr[i].mobimage;
                }
                return arr;
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*导航*/
.example-title {
   padding-bottom: .32rem;
}

</style>